/**
 * Where the API lives.
 *
 * Netlify builds set VITE_APP_URL to the API's own host. A build that leaves it empty is served
 * by the API itself (a Laravel Cloud preview of a pull request), so the API is the origin the
 * page was loaded from. Its address is not known until the preview deploys, which is after the
 * build has run.
 */
export const resolveApiOrigin = (configured: string | undefined, pageOrigin: string): string =>
  configured || pageOrigin;

export const apiOrigin = resolveApiOrigin(import.meta.env.VITE_APP_URL, window.location.origin);
